import Header from "../components/landing/Header";
import SavingsCalculator from "../components/landing/SavingsCalculator";
import CTASection from "../components/landing/CTASection";
import Footer from "../components/landing/Footer";

export default function CalculatorPage() {
  return (
    <main data-testid="calculator-page" className="relative">
      <Header />
      <SavingsCalculator />
      <CTASection />
      <Footer />
    </main>
  );
}
